/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AlerteDto } from '../models/alerte-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des alertes
 */
@Injectable({
  providedIn: 'root',
})
export class AlertesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation alerteGetList
   */
  static readonly AlerteGetListPath = '/api/alertes/list';

  /**
   * Renvoie la liste des alertes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alerteGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<AlerteDto>>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlerteGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AlerteDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des alertes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alerteGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteGetList(params?: {
  }): Observable<Array<AlerteDto>> {

    return this.alerteGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<AlerteDto>>) => r.body as Array<AlerteDto>)
    );
  }

  /**
   * Path part for operation alerteLoadList
   */
  static readonly AlerteLoadListPath = '/api/alertes/load-list';

  /**
   * Renvoie la liste des alertes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alerteLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alerteLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlerteLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des alertes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alerteLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alerteLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.alerteLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation alerteGet
   */
  static readonly AlerteGetPath = '/api/alertes/{id}';

  /**
   * Renvoie l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alerteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteGet$Response(params: {

    /**
     * Identifiant de l&#x27;alerte
     */
    id: number;
  }): Observable<StrictHttpResponse<AlerteDto>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlerteGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AlerteDto>;
      })
    );
  }

  /**
   * Renvoie l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alerteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteGet(params: {

    /**
     * Identifiant de l&#x27;alerte
     */
    id: number;
  }): Observable<AlerteDto> {

    return this.alerteGet$Response(params).pipe(
      map((r: StrictHttpResponse<AlerteDto>) => r.body as AlerteDto)
    );
  }

  /**
   * Path part for operation alertePut
   */
  static readonly AlertePutPath = '/api/alertes/{id}';

  /**
   * Met à jour l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alertePut$Response(params: {

    /**
     * Identifiant de l&#x27;alerte à mettre à jour
     */
    id: number;

    /**
     * Alerte
     */
    body: AlerteDto
  }): Observable<StrictHttpResponse<AlerteDto>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlertePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AlerteDto>;
      })
    );
  }

  /**
   * Met à jour l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alertePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alertePut(params: {

    /**
     * Identifiant de l&#x27;alerte à mettre à jour
     */
    id: number;

    /**
     * Alerte
     */
    body: AlerteDto
  }): Observable<AlerteDto> {

    return this.alertePut$Response(params).pipe(
      map((r: StrictHttpResponse<AlerteDto>) => r.body as AlerteDto)
    );
  }

  /**
   * Path part for operation alerteDelete
   */
  static readonly AlerteDeletePath = '/api/alertes/{id}';

  /**
   * Supprime l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alerteDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteDelete$Response(params: {

    /**
     * Identifiant de l&#x27;alerte à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlerteDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alerteDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  alerteDelete(params: {

    /**
     * Identifiant de l&#x27;alerte à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.alerteDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation alertePost
   */
  static readonly AlertePostPath = '/api/alertes';

  /**
   * Crée l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alertePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alertePost$Response(params: {

    /**
     * Alerte
     */
    body: AlerteDto
  }): Observable<StrictHttpResponse<AlerteDto>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlertePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AlerteDto>;
      })
    );
  }

  /**
   * Crée l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alertePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alertePost(params: {

    /**
     * Alerte
     */
    body: AlerteDto
  }): Observable<AlerteDto> {

    return this.alertePost$Response(params).pipe(
      map((r: StrictHttpResponse<AlerteDto>) => r.body as AlerteDto)
    );
  }

  /**
   * Path part for operation alerteSetPublicationStatus
   */
  static readonly AlerteSetPublicationStatusPath = '/api/alertes/{id}/publication';

  /**
   * Met à jour la publication de l'alerte spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `alerteSetPublicationStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alerteSetPublicationStatus$Response(params: {

    /**
     * Identifiant de l&#x27;alerte à mettre à jour
     */
    id: number;

    /**
     * Statut de publication de l'utilisateur
     */
    body: boolean
  }): Observable<StrictHttpResponse<AlerteDto>> {

    const rb = new RequestBuilder(this.rootUrl, AlertesService.AlerteSetPublicationStatusPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AlerteDto>;
      })
    );
  }

  /**
   * Met à jour la publication de l'alerte spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `alerteSetPublicationStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  alerteSetPublicationStatus(params: {

    /**
     * Identifiant de l&#x27;alerte à mettre à jour
     */
    id: number;

    /**
     * Statut de publication de l'utilisateur
     */
    body: boolean
  }): Observable<AlerteDto> {

    return this.alerteSetPublicationStatus$Response(params).pipe(
      map((r: StrictHttpResponse<AlerteDto>) => r.body as AlerteDto)
    );
  }

}
